<template>
  <div class="div">
    <!-- :before-close="handleClose" -->

    <div class="div-center">
      <el-tabs
        v-model="activeName"
        type="card"
        style="height: 100%"
        @tab-click="tabClick"
      >
        <el-tab-pane label="能耗分析" name="EnergyEcharts">
          <div class="div-top">
            <div class="div-top-search">
              <div>
                <div style="display: inline-block">
                  <span class="label">分析选项:</span>
                  <el-radio-group v-model="searchData.SortType" @change="getDataList">
                    <el-radio-button label="Amount">
                      <i class="icon icon-rmb1" style="font-size: 14px"></i>
                      金额分析</el-radio-button
                    >
                    <el-radio-button label="Qty">
                      <i class="icon icon-num" style="font-size: 14px"></i>
                      用量分析</el-radio-button
                    >
                  </el-radio-group>
                </div>
                <!-- <span class="label">分类选项:</span>
              <el-radio-group v-model="searchData.classType" @change="classTypeChange">
                <el-radio-button label="bui">楼栋分类</el-radio-button>
                <el-radio-button label="dev">设备分类</el-radio-button>
              </el-radio-group> -->
                <div style="display: inline-block">
                  <span class="label">时间选项:</span>
                  <el-radio-group v-model="searchData.TimeType" @change="timeTypeChange">
                    <el-radio-button label="YearMonth">年月</el-radio-button>
                    <el-radio-button label="Year">年份</el-radio-button>
                  </el-radio-group>
                </div>
                <div v-if="searchData.TimeType === 'Year'" style="display: inline-block">
                  <span class="label">选择年份:</span>
                  <span>
                    <el-date-picker
                      v-model="searchData.StartTimeYear"
                      type="year"
                      :picker-options="startYearOptions"
                      placeholder="选择年份"
                      value-format="yyyy"
                      style="width: 150px; text-align: center"
                      :clearable="false"
                      @change="getDataList"
                    >
                    </el-date-picker>
                    <span class="separator">至</span>
                    <el-date-picker
                      v-model="searchData.EndTimeYear"
                      type="year"
                      placeholder="结束年份"
                      :picker-options="endYearOptions"
                      value-format="yyyy"
                      :clearable="false"
                      @change="getDataList"
                      style="width: 150px; text-align: center"
                    >
                    </el-date-picker>
                  </span>
                </div>
                <div
                  v-if="searchData.TimeType === 'YearMonth'"
                  style="display: inline-block"
                >
                  <span class="label">选择年月:</span>
                  <el-date-picker
                    v-model="searchData.searchYear"
                    type="monthrange"
                    :picker-options="monthRangeOptions"
                    :clearable="false"
                    range-separator="至"
                    value-format="yyyyMM"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份"
                    @change="getDataList"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="search-item" v-loading="buildingLoading">
                <div class="label">选择楼栋分类:</div>
                <el-checkbox-group
                  v-model="searchData.Buildings"
                  @change="BuildingsListChange"
                >
                  <el-checkbox
                    v-for="item in BuildingsList"
                    :key="item.Id"
                    :label="item.Id"
                    :disabled="item.disabled"
                    >{{ item.Name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
              <div class="search-item" v-loading="deviceTypeLoading">
                <div class="label">选择设备分类:</div>
                <el-checkbox-group
                  v-model="searchData.DeviceTypes"
                  @change="DeviceTypesListChange"
                >
                  <el-checkbox
                    v-for="item in DeviceTypesList"
                    :key="item.Id"
                    :label="item.Id"
                    :disabled="item.disabled"
                    >{{ item.DicName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
            <el-divider direction="vertical" class="divider" />
            <div class="div-top-echarts" v-loading="loading">
              <EchartsDom
                type="pie"
                :data="echartsData.list || []"
                width="100%"
                :title="{
                  text: '能耗分布',
                  left: '10px',
                  top: '5px',
                }"
                :thousand-separator="true"
                :legendTop="0"
                legendPosition="top"
                :decimalPlaces="searchData.SortType === 'Qty' ? 0 : 2"
                height="100%"
              />
            </div>
          </div>
          <div v-loading="loading">
            <div class="echarts-container">
              <!-- <div class="dom-card left">
                <div class="dom-card-title df aic jub">
                  <span>能耗总体分布</span>
                  <span class="hint-text">
                    单位：（{{ searchData.SortType === "Qty" ? "度/方/升" : "元" }}）
                  </span>
                </div>
                <div style="height: calc(100% - 35px); width: 100%" class="df aic juc">
                  <EchartsDom
                    type="pie"
                    :data="echartsData.list || []"
                    width="100%"
                    :legendTop="10"
                    :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                    height="300px"
                  />
                </div>
              </div> -->

              <div class="w100 dom-card">
                <div class="dom-card-title df aic jub">
                  <span
                    >能耗{{
                      searchData.TimeType === "YearMonth" ? "月份" : "年度"
                    }}趋势</span
                  >
                  <span class="hint-text">
                    单位：（{{ searchData.SortType === "Qty" ? "度/方/升" : "元" }}）
                  </span>
                </div>

                <EchartsDom
                  type="bar2"
                  :data="echartsData.yearlist"
                  width="100%"
                  :grid="{
                    left: 60,
                    top: 40,
                    right: 40,
                    bottom: 30,
                  }"
                  legendTop="10px"
                  height="220px"
                  :isStack="false"
                  barMaxWidth="40px"
                  :thousand-separator="true"
                  :decimalPlaces="searchData.SortType === 'Qty' ? 0 : 2"
                >
                </EchartsDom>
              </div>
              <div class="w100 dom-card" style="margin-top: 10px">
                <div class="dom-card-title df aic jub">
                  <span>能耗累计分布</span>

                  <div>
                    <el-select
                      v-model="searchData.classType"
                      placeholder="请选择"
                      style="width: 250px"
                    >
                      <el-option label="按楼栋分布" value="bui"> </el-option>
                      <el-option label="按专业设备分布" value="dev"> </el-option>
                    </el-select>
                    <span class="hint-text">
                      单位：（{{ searchData.SortType === "Qty" ? "度/方/升" : "元" }}）
                    </span>
                  </div>
                </div>

                <div
                  style="width: 100%"
                  class="df flex-wrap aic"
                  v-if="searchData.classType == 'dev'"
                >
                  <EchartsDom
                    v-for="item in echartsData.tlist"
                    :key="item.name"
                    type="pie"
                    :data="item.value || []"
                    :title="{
                      text: item.name,
                      left: 'center',
                      top: '10px',
                    }"
                    :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                    legendTop="50px"
                    :labelOption="{
                      formatter: (params) => {
                        return params.value && params.value !== 0
                          ? `${params.name}:  ${params.percent}%`
                          : '';
                      },
                    }"
                    pie-radius="40%"
                    :pie-center="['50%', '60%']"
                    :width="'33%'"
                    height="200px"
                  />
                </div>
                <div
                  style="width: 100%"
                  class="df flex-wrap aic"
                  v-if="searchData.classType == 'bui'"
                >
                  <EchartsDom
                    v-for="item in echartsData.blist"
                    :key="item.name"
                    type="pie"
                    :data="item.value || []"
                    :title="{
                      text: item.name,
                      left: 'center',
                      top: '10px',
                    }"
                    :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                    legendTop="50px"
                    :labelOption="{
                      formatter: (params) => {
                        return params.value && params.value !== 0
                          ? `${params.name}:  ${params.percent}%`
                          : '';
                      },
                    }"
                    pie-radius="40%"
                    :pie-center="['50%', '60%']"
                    :width="'33%'"
                    height="200px"
                  />
                </div>

                <!-- <EchartsDom
                  type="bar2"
                  :data="echartsData.blist || []"
                  title="各楼栋能耗分布"
                  :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                  :is-stack="false"
                  width="100%"
                  height="300px"
                />
                <EchartsDom
                  type="bar2"
                  :data="echartsData.tlist || []"
                  title="各设备分类能耗分布"
                  width="100%"
                  :is-stack="false"
                  height="300px"
                  :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                /> -->
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
        </el-tab-pane>
        <el-tab-pane label="能耗明细数据" name="TotalEnergy">
          <el-row style="height: 40px">
            <el-date-picker
              v-model="searchYearMonth"
              type="monthrange"
              align="right"
              format="yyyyMM"
              value-format="yyyyMM"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
            <el-button type="primary" @click="getInfo" style="margin-left: 10px"
              >查询</el-button
            >
            <el-button
              type="warning"
              @click="handleExport"
              style="margin-left: 10px"
              icon="el-icon-download"
              >导出数据</el-button
            >
          </el-row>
          <el-table
            :data="tableData"
            ref="dialogTable"
            style="width: 100%"
            height="calc(100% - 90px)"
          >
            <el-table-column label="序号" width="50" type="index"> </el-table-column>
            <el-table-column label="年月" align="center" prop="YearMonth" sortable>
            </el-table-column>
            <el-table-column label="设备编号" align="center" prop="DeviceCode" sortable>
            </el-table-column>
            <el-table-column label="设备名称" align="center" prop="device_name" sortable>
            </el-table-column>
            <el-table-column label="能耗（耗用量/金额）" align="center">
              <el-table-column
                label="电"
                align="right"
                prop="ElectricityConsumptionAmout"
                sortable
              >
                <template slot-scope="scope">
                  {{ scope.row.ElectricityConsumptionQty || 0 }}/
                  {{ $tools.momenyFormat(scope.row.ElectricityConsumptionAmout, 2) }}
                </template>
              </el-table-column>

              <el-table-column label="水" align="right" prop="WaterAmount" sortable>
                <template slot-scope="scope">
                  {{ scope.row.WaterConsumptionQty || 0 }}/
                  {{ $tools.momenyFormat(scope.row.WaterAmount, 2) }}
                </template>
              </el-table-column>

              <el-table-column label="气" align="right" prop="GasAmount" sortable>
                <template slot-scope="scope">
                  {{ scope.row.GasConsumptionQty || 0 }}/
                  {{ $tools.momenyFormat(scope.row.GasAmount, 2) }}
                </template>
              </el-table-column>

              <el-table-column label="油" align="right" prop="OilAmount" sortable>
                <template slot-scope="scope">
                  {{ scope.row.OilConsumptionQty || 0 }}/
                  {{ $tools.momenyFormat(scope.row.OilAmount, 2) }}
                </template>
              </el-table-column>

              <el-table-column label=" 小计" align="right" prop="TotalAmt" sortable>
                <template slot-scope="scope">
                  {{ scope.row.TotalQty || 0 }}/
                  {{ $tools.momenyFormat(scope.row.TotalAmt, 2) }}
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              style="margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import tools from "@/utils/tools.js";
import moment from "moment";
import { mapState } from "vuex";

import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
export default {
  data() {
    return {
      moment,
      tools,
      loading: false,
      activeName: "EnergyEcharts",
      searchYearMonth: "",
      searchYear: "",
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      searchData: {
        SortType: "Amount",
        TimeType: "YearMonth",
        classType: "bui",
        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      BuildingsList: [],
      DeviceTypesList: [],
      echartsData: {
        list: [],
      },
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetDataList: null,
      monthRangePicking: { minDate: null, maxDate: null },
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    DeviceTypesListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetDataList();
    },
    BuildingsListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }

      this.debouncedGetDataList();
    },
    getDataList() {
      this.loading = true;
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.$http
        .post("/PB/PB_Project/GetEnergySummaryAnalysis", {
          SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.loading = false;
          if (res.Success) {
            this.echartsData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getDataList();
    },
    classTypeChange() {
      if (this.searchData.classType == "bui") {
        this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
      } else if (this.searchData.classType == "dev") {
        this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
      }
    },
    //获取楼栋列表
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    tabClick(tab) {
      this.activeName = tab.name;

      if (this.activeName !== "EnergyEcharts") {
        this.getInfo();
      }
    },
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/Base_DeviceTreeManage/DeviceItem/ReportEnergyExportToExcel?DeviceType=${
            this.devTreeSearch.DeviceType || ""
          }&BuildingId=${this.devTreeSearch.BuildingId || ""}&InstallationArea=${
            this.devTreeSearch.InstallationArea || ""
          }&YearMonth=${
            this.searchYearMonth?.length > 0 ? this.searchYearMonth.join(",") : ""
          }`,
        "设备总能耗",
        ".xlsx",
        "get"
      );
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex;
      this.getInfo();
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1;
      this.pagination.PageRows = PageRows;
      this.getInfo();
    },
    getInfo() {
      this.loading = true;
      this.$http
        .post("/Base_DeviceTreeManage/DeviceItem/GetDeviceItemReportEnergyList", {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: "Id",
          SortType: "Desc",
          Search: [
            {
              Condition: "DeviceType",
              Keyword: this.devTreeSearch.DeviceType || "",
            },
            {
              Condition: "BuildingId",
              Keyword: this.devTreeSearch.BuildingId || "",
            },
            {
              Condition: "InstallationArea",
              Keyword: this.devTreeSearch.InstallationArea || "",
            },
            {
              Condition: "YearMonth",
              Keyword:
                this.searchYearMonth?.length > 0 ? this.searchYearMonth.join(",") : "",
            },
          ],
        })
        .then((resJson) => {
          this.loading = false;
          if (resJson.Success) {
            this.tableData = resJson.Data || [];
            this.pagination.total = resJson.Total || 0;
          } else {
            this.$notify.error(resJson.Msg);
          }
        });
    },

    close() {
      this.drawer = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
  },
  mounted() {},
  async created() {
    this.debouncedGetDataList = tools.debounce(function () {
      this.getDataList();
    }, 500);
    // 初始化为当前月份和前一个月的范围
    const currentDate = new Date();
    const currentMonth = this.$tools.timeFormat(currentDate, "YYYYMM");
    const previousMonth = this.$tools.timeFormat(
      new Date(currentDate.getFullYear(), 0, 1),
      "YYYYMM"
    );
    this.searchYearMonth = [previousMonth, currentMonth];

    this.searchData.StartTimeYear = moment().format("YYYY");
    this.searchData.EndTimeYear = moment().format("YYYY");
    this.searchData.searchYear = [
      moment().startOf("year").format("YYYYMM"),
      moment().endOf("year").format("YYYYMM"),
    ];
    this.loading = true;
    await this.getProjectDeviceTypeList();
    await this.getBuildingDataList();
    this.getDataList();
  },
  computed: {
    ...mapState(["devTreeSearch"]),
    monthRangeOptions() {
      return {
        onPick: ({ minDate, maxDate }) => {
          this.monthRangePicking = { minDate, maxDate };
        },
        disabledDate: (time) => {
          const { minDate, maxDate } = this.monthRangePicking || {};
          if (minDate && !maxDate) {
            // 限制最大跨度为12个月（含起始月，共12）
            const diffMonths = Math.abs(moment(time).diff(moment(minDate), "months"));
            return diffMonths > 11;
          }
          return false;
        },
      };
    },
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {
    devTreeSearch() {
      if (this.activeName !== "EnergyEcharts") {
        this.getInfo();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.div-center {
  height: calc(100%);
}
.tab-chart-container {
  width: 100%;
  height: 300px;
  min-height: 200px;
  box-sizing: border-box;
}
.tab-chart-pieList {
  width: 100%;
  height: 200px;
  min-height: 150px;
  box-sizing: border-box;
}
.pie-charts-container {
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
}
.pie-chart-item {
  width: calc(100% / 12);
  min-width: 80px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}
.pie-chart-item:last-child {
  border-right: none;
}
.chart-card {
  margin-bottom: 16px;
}
::v-deep .el-card__header {
  font-weight: bold;
}
@media (max-width: 1200px) {
  .pie-chart-item {
    width: calc(100% / 6);
  }
}
@media (max-width: 800px) {
  .pie-chart-item {
    width: calc(100% / 3);
  }
  .tab-chart-container {
    height: 220px;
  }
  .tab-chart-pieList {
    height: 120px;
  }
}

.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;
}
.separator {
  font-size: 12px;
  margin: 0 10px;
}
::v-deep .el-date-editor {
  .el-input__inner {
    text-align: center;
  }
}
.echarts-container {
  width: 100%;
  margin-top: 10px;
  // display: flex;
  // align-items: center;
  // gap: 20px;
  // height: auto;
  // align-items: stretch;
  .left {
    width: 30%;
    height: auto;
  }
  .right {
    width: 70%;
    height: auto;
  }
}
::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
::v-deep .el-card__body {
  width: 100%;
  height: 100%;
  padding: 0;
}
.div-top {
  display: flex;
  align-items: stretch;
  min-height: 150px;
  .div-top-search {
    width: 70%;
    height: auto;
  }
  .div-top-echarts {
    width: 30%;
    height: auto;
    // background-color: red;
  }
}
::v-deep .divider {
  height: auto;
}
.card-selet {
  text-align: right;
}
</style>
